
  function mobileClose(device, jsonString){
    // console.log('20200207 : ' + device)
    // console.log('20200207 : ' + jsonString)
    if (device == 'android') {
      //在js中呼叫 window.AndroidWebView.showInfoFromJs(name)，便會觸發此 android 方法。
      // window.AndroidWebView.showInfoFromJs('6809/4320777')
      // window.AndroidWebView.showInfoFromJs('{"categoryId":6813,"articleId":4320991}')
      // window.AndroidWebView.showInfoFromJs('{"categoryId":6813,"articleId":4320991,"date":20200504}')
      window.AndroidWebView.showInfoFromJs(jsonString)
    } else {
      window.webkit.messageHandlers.botclosed.postMessage(jsonString)
    }

  }
  
  export {mobileClose}
  


// WEBPACK FOOTER //
// ./src/pages/js/mobileClose.js